module.exports = __webpack_public_path__ + "static/media/ava2.010bd1d7.svg";